import { render, staticRenderFns } from "./UsersGroups.vue?vue&type=template&id=7053d44c&scoped=true&"
import script from "./UsersGroups.vue?vue&type=script&lang=js&"
export * from "./UsersGroups.vue?vue&type=script&lang=js&"
import style0 from "./UsersGroups.vue?vue&type=style&index=0&id=7053d44c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7053d44c",
  null
  
)

export default component.exports